var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"retrieval"},[(_vm.notes.length>0)?_c('div',[_vm._v("注释")]):_c('div',[_vm._v("暂无注释")]),_vm._l((_vm.notes),function(item,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(item)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }